import React from 'react'
import { Box, Typography } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel, { formControlLabelClasses } from '@mui/material/FormControlLabel'
import { updateMonitoredBusiness } from 'store/actions/businessListingActions'
import { useSelector, useDispatch } from 'react-redux'
import ButtonTooltip from 'components/Common/ToolTip/ButtonTooltip'
import Link from '@mui/material/Link'
import { useNavigate } from 'react-router-dom'

const sx = {
  label: {
    [`&.${formControlLabelClasses.root}`]: {
      marginLeft: "0px"
    }
  }
}

const MonitorButton = ({ company }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const businessReducer = useSelector(state => state.businessReducer)
  const userInfo = useSelector(state => state.userReducer)
  const isFreeAccount = userInfo?.user?.accountType !== 'premium'
  const handleMonitor = e => {
    const { checked } = e.target
    updateMonitoredBusiness(dispatch, {
      addIds: checked ? [company.ext_id] : [],
      removeIds: checked ? [] : [company.ext_id],
    })
  }
  const isMonitered = businessReducer.monitoredCompanies.monitorCompanyIds?.includes(company.ext_id)
  return (
    <>
      {isFreeAccount && (
        <Box display="flex" gap="15px" alignItems="center">
          <ButtonTooltip
            placement="top"
            width="320px"
            arrow
            title={
              <Box>
                <Typography component="span" variant="body2" color="white">
                  A&nbsp;
                </Typography>
                <Link underline="hover" sx={{ cursor: 'pointer', textDecorationColor: 'white !important' }}>
                  <Typography component="span" variant="button2" color="white" onClick={() => navigate('/welcome')}>
                    subscription
                  </Typography>
                </Link>
                <Typography component="span" variant="body2" color="white">
                  &nbsp;is required to add businesses and view them on your followed businesses page.
                </Typography>
              </Box>
            }
          >
            <FormControlLabel
              control={<Checkbox size="large" checked={false} disabled />}
              // label={<Typography variant="body2B">Follow</Typography>}
              sx={sx.label}
            />
          </ButtonTooltip>
        </Box>
      )}
      {!isFreeAccount && (
        <Box display="flex" gap="15px" alignItems="center">
          {/* {isMonitered ? (
            <VisibilityOutlinedIcon sx={{ fontSize: '24px' }} color={'info'} />
          ) : (
            <VisibilityOffOutlinedIcon sx={{ fontSize: '24px' }} color={'disabled'} />
          )} */}
          <FormControlLabel
            control={<Checkbox size="large" sx={{ color: isMonitered ? '#0a78cd !important' : '#bdbdce' }} checked={isMonitered} onChange={e => handleMonitor(e)} />}
            // label={<Typography variant="body2">{`${isMonitered ? 'Unfollow' : 'Follow'}`}</Typography>}
            sx={sx.label}
          />
        </Box>
      )}
    </>
  )
}

export default MonitorButton
